// AppWrap is a Higher Order Component
// It wraps our sections/components giving it a 
// 1. 100% height view of the screen 
// 2. Social Media Icons 
// 3. CopyRight tag 
// 4. Navigation Dots 
// => No need to implement these 4 things in each section tediously 
// => Promotes Reusability 
// The 3 main things AppWrap takes in as argument is : 
// 1. Section/Component 
// 2. idName to give that Section/Component 
// 3. classNames for that section background color 

import React from 'react';
import { NavigationDots, SocialMedia } from '../components';

// Converting our AppWrap to a Higher Order Component 
const AppWrap = (Component, idName, classNames) => function HOC() {
  return (
    // We are taking a specific section, wrapping it 
    // Giving the secion an id and a className
    <div id={idName} className={`app__container ${classNames}`} >

        {/* SocialMedia icons */}
        <SocialMedia />

        {/* Section with Copyright */}
        <div className='app__wrapper app__flex'>
            {/* This <Component /> is the section we are wrapping (Header etc..) */}
            <Component />

            <div className='copyright'>
                <p className='p-text'>@2022 TWZ</p>
                <p className='p-text'>All rights reserved</p>
            </div>
        </div>

        {/* NavigationDots  */}
        {/* Note : active tells the NavigationDots which section we are on currently */}
        <NavigationDots active={idName}/>
        
    </div>
  )
}

export default AppWrap